import { baseUrl, GetHeaders, handleResponse, handleError, PostOptions, DeleteHeaders, PutOptions } from "../common/ApiUtils";

const apiUrl = baseUrl + "AvailableHours/";

export function getConsultantsWithAvailableHours() {
  return fetch(apiUrl + "consultants", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getAvailableHours(isAdmin = false, userId = null) {
  if (isAdmin && userId) {
    return fetch(apiUrl + "?consultantId=" + userId, GetHeaders())
      .then(handleResponse)
      .catch(handleError);
  }
  return fetch(apiUrl, GetHeaders()).then(handleResponse).catch(handleError);
}

export function putAvailableHours(availableHoursId, updatedRecord) {
  return fetch(`${apiUrl}${availableHoursId}`, PutOptions(updatedRecord)).then(handleResponse).catch(handleError);
}

export function getAvailableHoursHistory(isAdmin = false, userId = null) {
  if (isAdmin && userId) {
    return fetch(apiUrl + "history?consultantId=" + userId, GetHeaders())
      .then(handleResponse)
      .catch(handleError);
  }
  return fetch(apiUrl + "history", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getTotalValueAvailable() {
  return fetch(apiUrl + "total", GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getTotalValueAvailable_Manager(userId) {
  return fetch(apiUrl + "total/manager/" + userId, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getTotalValueAvailable_Admin(userId) {
  return fetch(apiUrl + "total/admin/" + userId, GetHeaders())
    .then(handleResponse)
    .catch(handleError);
}

export function getAvailableHoursNotes(availableHoursId) {
  return fetch(`${apiUrl}notes/${availableHoursId}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function postAvailableHoursNote(note) {
  return fetch(apiUrl + "notes", PostOptions(note))
    .then(handleResponse)
    .catch(handleError);
}

export function updateAvailableHoursNote(noteId, note) {
  return fetch(`${apiUrl}notes/${noteId}`, PutOptions(note)).then(handleResponse).catch(handleError);
}

export function deleteAvailableHoursNote(noteId) {
  return fetch(`${apiUrl}notes/delete/noteId}`, DeleteHeaders()).then(handleResponse).catch(handleError);
}

export function getQuarterHourBreakdownDetails(availableHoursId) {
  return fetch(`${apiUrl}details/${availableHoursId}`, GetHeaders()).then(handleResponse).catch(handleError);
}
